export enum FreelancerSignupTrackingEvent {
    ACTION_PERFORMED = 'profile_creation_actions_performed',
    CREATION_STARTED = 'profile_creation_started',
    STEP_VIEWED = 'profile_creation_step_viewed',
}

export enum FreelancerSignupTrackingContext {
    OPEN = 'open',
    NONE = '',
}

export enum FreelancerSignupTrackingVertical {
    REGULAR = 'regular',
    STRATEGY = 'strategy',
}

export enum FreelancerSignupTrackingActionContextStepSaved {
    ACCOUNT_CREATION_WITH_EMAIL = 'email',
    ACCOUNT_CREATION_WITH_SSO = 'sso',
    CATEGORY_SELECTED_MANUALLY = 'category_selected_manually',
    CATEGORY_SELECTED_WITH_PREDICTIONS = 'category_selected_with_predictions',
    COMPLETION_MODE_SELECTION_MANUAL = 'manual',
    COMPLETION_MODE_SELECTION_UPLOAD = 'upload',
    IMPORT_WITH_EDITION = 'experience_imported_with_edition',
    IMPORT_WITHOUT_EDITION = 'experience_imported_without_edition',
    NONE = '',
}

export enum FreelancerSignupTrackingEntryPoint {
    FREELANCER_INVITATION = 'freelancer_invitation',
    MALT_OPEN_INVITATION = 'malt_open_invitation',
    MALT_STRATEGY_REDIRECTION = 'malt_strategy_redirection',
    NONE = '',
}

export enum FreelancerSignupTrackingStepName {
    WELCOME_TO_MALT = 'welcome_to_malt',
    FREELANCING_EXPERIENCE = 'freelancing_experience',
    DESCRIBE_YOURSELF = 'describe_yourself',
    ACCOUNT_CREATION = 'account_creation',
    EMAIL_ACCOUNT_CREATION = 'account_creation_entry_step',
    ACCOUNT_SSO_COMPLETION = 'account_sso_completion',
    EMAIL_VERIFICATION = 'email_verification',
    COMPLETION_MODE_SELECTION = 'completion_mode_selection',
    EXPERIENCES = 'experiences',
    EDUCATION = 'education',
    JOB_TITLE = 'job_title',
    CATEGORY_SELECTION = 'category_selection',
    WORKING_LANGUAGES = 'working_languages',
    EXPERIENCE_LEVEL = 'experience_level',
    DAILY_RATE = 'daily_rate',
    WORKING_LOCATION = 'working_location',
    PROFILE_PICTURE = 'profile_picture',
    PHONE_NUMBER = 'phone_number',
    PRIVACY_SETTINGS = 'privacy_settings',

    // Regular & Open
    TOP_SKILLS = 'top_skills',

    // Strategy
    YOUR_FUNCTIONAL_AND_GLOBAL_SKILLS = 'your_functional_and_global_skills',

    // steps out of workflow
    WELCOME_BACK = 'welcome_back',
    REMINDER = 'reminder',
}

export enum FreelancerSignupTrackingEventActionPerformedActionName {
    STEP_SAVED = 'step_saved',
    STEP_SKIPPED = 'step_skipped',
}

export type FreelancerSignupTrackingEventActionPerformedPayload = {
    workflow_id: string;
    step_name: FreelancerSignupTrackingStepName;
    context: FreelancerSignupTrackingContext;
    vertical: FreelancerSignupTrackingVertical;
    action_name: FreelancerSignupTrackingEventActionPerformedActionName;
    action_context: FreelancerSignupTrackingActionContextStepSaved;
};

export type FreelancerSignupTrackingEventCreationStartedPayload = {
    workflow_id: string;
    vertical: FreelancerSignupTrackingVertical;
    context: FreelancerSignupTrackingContext;
    entry_point: FreelancerSignupTrackingEntryPoint;
    version: string;
};

export type FreelancerSignupTrackingEventStepViewPayload = {
    workflow_id: string;
    step_name: FreelancerSignupTrackingStepName;
    context: FreelancerSignupTrackingContext;
    vertical: FreelancerSignupTrackingVertical;
};
